import React, { FC, useCallback } from 'react';
import type { ILegoElemProps } from '../../Lego';
import { useLegoFormContext } from '../../_FormProvider/useLegoFormContext';
import { ILegoElemUploader } from '../models';
import { Uploader } from '@src/molecules/Uploader';

export const LegoElemUploader: FC<ILegoElemProps> = ({ elem, loading }) => {
  const { formHook } = useLegoFormContext();
  const mediaUploaderElem = elem as ILegoElemUploader;
  const value = formHook.watch(elem.id);

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLFormElement>) => {
      formHook.setValueAndRevalidate(elem.id, event.target.value);
    },
    [elem.id, formHook],
  );

  return (
    <Uploader
      {...mediaUploaderElem.uploader}
      id={elem.id}
      value={value}
      onChange={handleOnChange}
      disabled={mediaUploaderElem.uploader.disabled ? true : loading}
    />
  );
};
